var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feature-request-card" }, [
    _c("div", { staticClass: "vote-section" }, [
      _c("div", { staticClass: "vote-count" }, [
        _vm._v("\n      " + _vm._s(_vm.request.votes) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vote-label" }, [_vm._v("\n      votes\n    ")]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-section" },
      [
        _c(
          "div",
          { staticClass: "title-row", on: { click: _vm.toggleExpanded } },
          [
            _c("h3", { staticClass: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.request.title) + "\n      "),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "expand-icon",
              class: _vm.expanded ? "el-icon-arrow-up" : "el-icon-arrow-down",
            }),
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "expand" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expanded,
                  expression: "expanded",
                },
              ],
              staticClass: "message",
            },
            [_vm._v("\n        " + _vm._s(_vm.request.message) + "\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: _vm.hasVoted ? "info" : "primary",
                  size: "small",
                  loading: _vm.upvoting,
                  disabled: _vm.hasVoted,
                },
                on: { click: _vm.handleUpvote },
              },
              [
                _c("i", {
                  class: _vm.hasVoted ? "el-icon-check" : "el-icon-caret-top",
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.hasVoted ? "Voted" : "Upvote") +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.canDelete
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      size: "small",
                      loading: _vm.deleting,
                    },
                    on: { click: _vm.handleDelete },
                  },
                  [
                    _c("i", { staticClass: "el-icon-delete" }),
                    _vm._v("\n        Delete\n      "),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }